module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-185.5ec4e6e.woff2";